module.exports = __webpack_public_path__ + "static/media/corona_1.6ec3096d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/corona_1.jpg
// module id = 1019
// module chunks = 0